var map = {
	"./vc-za-btj/assets/game-logo.png": 2727,
	"./vc-za-ff/assets/game-logo.png": 2929,
	"./vc-za-h2h/assets/game-logo.png": 5137,
	"./vc-za-qi/assets/game-logo.png": 7347,
	"./vc-za-stc/assets/game-logo.png": 6943,
	"./vc-za-u3/assets/game-logo.png": 6157
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7142;